import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  List,
  ListItem,
  ListItemText,
  Typography,
  IconButton,
} from "@mui/material";
import { IniInfo } from "system/types/interfaces"; 
import { EditRegular } from "@fluentui/react-icons";
interface InvalidRulesModalProps {
  open: boolean;
  onClose: () => void;
  invalidRules: { index: number; rule: IniInfo; errors: string[] }[];
  onNavigate: (rule: IniInfo, index: number) => void;
}

const InvalidRulesModal: React.FC<InvalidRulesModalProps> = ({ open, onClose, onNavigate, invalidRules }) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>Invalid Rules Found</DialogTitle>
      <DialogContent>
        <Typography variant="body1" gutterBottom>
          The following rules contain errors. Please review and correct them:
        </Typography>
        <List>
          {invalidRules.map(({ index, rule, errors }) => (
            <ListItem
              key={index}
              divider
              secondaryAction={
                <IconButton edge="end" onClick={() => onNavigate(rule, index - 1)} color="primary">
                  <EditRegular fontSize={22} />
                </IconButton>
              }
            >
              <ListItemText
                primary={
                  <Typography variant="body2" color="text.primary">
                    <strong>{`${index}: ${rule.name} ${rule.delimiter} ${rule.value}`}</strong>
                  </Typography>
                }
                secondary={
                  <List dense>
                    {errors.map((error, idx) => (
                      <ListItem key={idx} sx={{ pl: 0, pb: 0 }}>
                        <Typography variant="body2" color="#d5878b">
                          {error.replace(/Row \d+: /, "")}
                        </Typography>
                      </ListItem>
                    ))}
                  </List>
                }
                primaryTypographyProps={{ color: "text.primary" }}
                secondaryTypographyProps={{ component: "div" }}
              />
            </ListItem>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained" color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default InvalidRulesModal;
